import styles from './Hero.module.css'
import {NavBarHeight} from "../../utils/Constants";
import {PrimaryButton} from "../../components/button/Button";

export function Hero({children,url, megaphone,titles,shortdescription}){
    return <>
        <section className="cover-background full-screen ipad-top-space-margin py-0 md-h-750px sm-h-650px"
                 style={{
                     backgroundImage: "url("+url+")"
                 }}>
            <div className="opacity-very-light bg-black"></div>
            <div id="particles-style-01" className="position-absolute h-100 top-0 left-0 w-100" data-particle="true"
                 data-particle-options={JSON.stringify({
                     "particles": {
                         "number": {"value": 80, "density": {"enable": true, "value_area": 800}},
                         "color": {"value": "#232323"},
                         "shape": {
                             "type": "circle",
                             "stroke": {"width": 0, "color": "#232323"},
                             "polygon": {"nb_sides": 5},
                             "image": {"src": "img/github.svg", "width": 100, "height": 100}
                         },
                         "opacity": {
                             "value": 0.4,
                             "random": false,
                             "anim": {"enable": false, "speed": 1, "opacity_min": 0.1, "sync": false}
                         },
                         "size": {
                             "value": 4,
                             "random": true,
                             "anim": {"enable": false, "speed": 40, "size_min": 0.1, "sync": false}
                         },
                         "line_linked": {
                             "enable": true,
                             "distance": 150,
                             "color": "#232323",
                             "opacity": 0.3,
                             "width": 1
                         },
                         "move": {
                             "enable": true,
                             "speed": 6,
                             "direction": "none",
                             "random": false,
                             "straight": false,
                             "out_mode": "out",
                             "bounce": false,
                             "attract": {"enable": false, "rotateX": 600, "rotateY": 1200}
                         }
                     },
                     "interactivity": {
                         "detect_on": "canvas",
                         "events": {
                             "onhover": {"enable": true, "mode": "repulse"},
                             "onclick": {"enable": true, "mode": "push"},
                             "resize": true
                         },
                         "modes": {
                             "grab": {"distance": 400, "line_linked": {"opacity": 1}},
                             "bubble": {"distance": 400, "size": 40, "duration": 2, "opacity": 8, "speed": 3},
                             "repulse": {"distance": 200, "duration": 0.4},
                             "push": {"particles_nb": 4},
                             "remove": {"particles_nb": 2}
                         }
                     },
                     "retina_detect": true
                 })}></div>
            <div className="shape-image-animation bottom-0 p-0 w-100 d-none d-md-block">
                <svg xmlns="http://www.w3.org/2000/svg" widht="3000" height="400" viewBox="0 180 2500 200"
                     fill="#ffffff">
                    <path className="st1" d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250">
                        <animate attributeName="d" dur="5s" values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250" repeatCount="indefinite"/>
                    </path>
                </svg>
            </div>
            <div className="container h-100">
                <div className="row align-items-center h-100">
                    <div className="col-xl-6 col-lg-8 col-md-10 position-relative z-index-1"
                         data-anime='{ "el": "childs", "translateY": [0, 0], "perspective": [1200,1200], "scale": [1.05, 1], "rotateX": [30, 0], "opacity": [0,1], "duration": 800, "delay": 200, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <span
                            className="ps-25px pe-25px pt-5px pb-5px mb-25px text-uppercase text-white fs-12 ls-1px fw-600 border-radius-100px bg-gradient-dark-gray-transparent d-flex w-70 sm-w-100"><i
                            className="bi bi-megaphone text-white icon-small me-10px"></i>FOR SHAPING SUCCESS</span>
                        <h1 className="text-white fw-600 ls-minus-2px mb-25px">BeneFit SHARE</h1>
                        <h1 className="text-white fw-600 ls-minus-2px mb-25px">Konferencia 2025</h1>
                        <div>
                            <p className="fw-300 fs-18 w-85 sm-w-95 text-white opacity-6" style={{fontSize:"24px"}}>2025.05.20. kedd 8:00-16:30,<br/>Magyar Tudományos Akadémia<br/>1051 Budapest, Széchenyi István tér 9</p>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </section>
    </>
}

export function CenterHero({children, url, megaphone, titles, fill = "#ffffff"}) {
    return (
        <section className="pt-0 cover-background ipad-top-space-margin sm-pb-0"
                 style={{
                     backgroundImage: "url(" + url + ")",
                     marginTop: "inherit"
                 }}>
            <div className="shape-image-animation p-0 w-100 d-none d-md-block">
                <svg xmlns="http://www.w3.org/2000/svg" height="400" viewBox="0 180 2500 200"
                     fill={fill}>
                    <path className="st1" d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250">
                        <animate attributeName="d" dur="5s" values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250" repeatCount="indefinite"/>
                    </path>
                </svg>
            </div>
            <div className="container">
                <div className="row align-items-center justify-content-center h-500px sm-h-300px">
                    <div
                        className="col-12 col-lg-6 col-md-10 position-relative text-center page-title-extra-large d-flex flex-wrap flex-column align-items-center justify-content-center"
                        data-anime={JSON.stringify({
                            "el": "childs",
                            "translateY": [30, 0],
                            "opacity": [0, 1],
                            "duration": 600,
                            "delay": 0,
                            "staggervalue": 300,
                            "easing": "easeOutQuad"
                        })}>
                        <span
                            className="ps-25px pe-25px pt-5px pb-5px mb-15px text-uppercase text-white fs-12 ls-1px fw-600 border-radius-100px bg-gradient-dark-gray-transparent d-flex"><i
                            className="bi bi-megaphone text-white icon-small me-10px"></i>{megaphone}</span>
                        {titles.map((title, idx) => {
                            return <h1 key={idx} className="text-white fw-600 ls-minus-2px mb-25px">{title}</h1>
                        })}

                        {children}
                    </div>
                </div>
            </div>
        </section>
    )
}

export function TicketHero({children,titles, megaphone}) {
    /**
     Csak árnyékolásban tér el, ez az egy hero típus, amúgy helyettesíthető lenne:


     <CenterHero
     url={'/benefitshare/img/headerbg2.jpg'}
     megaphone={"Let's make something great work together."}
     titles={["Sharing ideas, shaping success.Big ideas for happy employees."]}
     >
     <PrimaryButton href={''} primaryText={'Jegy vásárlása'} secondaryText={'Biztosítsd be a helyed'}></PrimaryButton>
     </CenterHero>

     */
    return (
        <section className="cover-background one-third-screen sm-h-500px pb-0 position-relative"
                 style={{backgroundImage: "url('/benefitshare/img/headerbg2.jpg')"}}>
            <div className="opacity-extra-medium bg-dark-gray"></div>
            <div className="container h-100">
                <div className="row align-items-center justify-content-center h-100">
                    <div
                        className="col-xl-8 col-lg-10 mb-9 md-mb-15 position-relative z-index-1 text-center d-flex flex-wrap align-items-center justify-content-center"
                        data-anime='{ "el": "childs", "translateY": [50, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                        <span
                            className="ps-25px pe-25px pt-5px pb-5px mb-25px text-uppercase text-white fs-12 ls-1px fw-600 border-radius-100px bg-gradient-dark-gray-transparent d-inline-flex align-items-center text-start sm-lh-20"><i
                            className="bi bi-megaphone text-white d-inline-block align-middle icon-small me-10px"></i> {megaphone}</span>
                        {titles.map((title, idx) => {
                            return <h1 key={idx} className="text-white fw-600 ls-minus-2px mb-50px">{title}</h1>
                        })}
                        {children}
                    </div>
                </div>
            </div>
            <div className="shape-image-animation p-0 w-100 bottom-minus-40px xl-bottom-0px d-none d-md-block">
                <svg xmlns="http://www.w3.org/2000/svg" widht="3000" height="400" viewBox="0 180 2500 200"
                     fill="#ffffff">
                    <path className="st1" d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250">
                        <animate attributeName="d" dur="5s" values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250" repeatCount="indefinite"/>
                    </path>
                </svg>
            </div>
        </section>
    )
}